/* sxf-count.js: keeps the drawing count on sxf.art current.
   Reads stats.json from the public archive folder (written by archive-catalog/generate_stats.py at
   the end of every intake commit) and updates:
     - any element with data-sxf-stat="highest|floor|scanned|year:2026" (text replaced by the number)
     - any typed claim like "8,600+", "8,600 since 2021" or "8,600 numbered", so plain-text settings
       (the homepage hero) stay current without markup.
   If anything fails, the hand-typed number on the page simply stays. Cached 10 min per tab. */
(function () {
  var API_KEY = "AIzaSyBCS9QF0IPlojZvXsqGAfUyWEiNR9oyueE";
  var FOLDER_ID = "1blSr8Ug1kendXdAYM66udQzhF8UnvxaX";
  var CACHE = "sxf-stats-v1";
  var CLAIM = /\b\d{1,2},\d00(?=\+|\s+since 2021|\s+numbered)/gi;
  var HAS = /\b\d{1,2},\d00(?=\+|\s+since 2021|\s+numbered)/i;  /* no g flag, so .test() keeps no lastIndex */

  function fmt(n) { return n.toLocaleString("en-US"); }

  function fill(s) {
    if (!s || typeof s.floor !== "number") return;
    document.querySelectorAll("[data-sxf-stat]").forEach(function (el) {
      var k = el.getAttribute("data-sxf-stat");
      var v = k.indexOf("year:") === 0 ? (s.by_year || {})[k.slice(5)] : s[k];
      if (typeof v === "number") el.textContent = fmt(v);
    });
    var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === "SCRIPT" || p === "STYLE" || p === "TEXTAREA") return NodeFilter.FILTER_REJECT;
        return HAS.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var hits = [];
    while (walk.nextNode()) hits.push(walk.currentNode);
    hits.forEach(function (n) { n.nodeValue = n.nodeValue.replace(CLAIM, fmt(s.floor)); });
  }

  try {
    var c = JSON.parse(sessionStorage.getItem(CACHE) || "null");
    if (c && Date.now() - c.t < 600000) { fill(c.s); return; }
  } catch (e) {}

  var q = new URLSearchParams({
    q: "'" + FOLDER_ID + "' in parents and name='stats.json' and trashed=false",
    key: API_KEY, fields: "files(id)", supportsAllDrives: "true", includeItemsFromAllDrives: "true"
  });
  fetch("https://www.googleapis.com/drive/v3/files?" + q.toString())
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d.files || !d.files[0]) return null;
      return fetch("https://www.googleapis.com/drive/v3/files/" + d.files[0].id + "?alt=media&key=" + API_KEY)
        .then(function (r) { return r.json(); });
    })
    .then(function (s) {
      if (!s) return;
      fill(s);
      try { sessionStorage.setItem(CACHE, JSON.stringify({ t: Date.now(), s: s })); } catch (e) {}
    })
    .catch(function () {});
})();
